exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-info-link:hover{-webkit-transition:all .15s;transition:all .15s}.footer-info-sns{margin:0 .3em}.footer-info-sns:hover{-webkit-animation:pop .45s;animation:pop .45s}.footer-info-sns .fa{padding:0 .3em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/footer/FooterCompany1/FooterCompany1.l.scss
// module id = 1241
// module chunks = 14